module.exports = __webpack_public_path__ + "static/media/signage-indoor-img22.91106a6b.jpg";